import { observer } from 'mobx-react';
import clsx from 'clsx';
import Button from '../../../../../../../Form/Button';

interface Props {
  close: () => void;
  save: () => void;
  disabled: boolean;
}

function Buttons({ save, close, disabled }: Props) {
  return (
    <div className="flex justify-end">
      <Button
        type="button"
        value="Discard changes"
        onClick={close}
        className={clsx(
          'rounded bg-white px-5 py-2.5 text-sm',
          'text-teal-600 disabled:opacity-60',
        )}
      />
      <Button
        type="button"
        value="Save"
        onClick={save}
        disabled={disabled}
        className={clsx(
          'ml-2 rounded bg-teal-600 px-5 py-2.5 text-sm',
          'text-white disabled:opacity-60',
        )}
      />
    </div>
  );
}

export default observer(Buttons);
